module.exports = __webpack_public_path__ + "img/waze.3988596b.svg";